<script>
    // @ts-nocheck
    import { onMount } from 'svelte';
    import { fly } from 'svelte/transition';

	import Card from '$lib/components/default/card.svelte';
    import CategoryCard from './default/categoryCard.svelte';

    import MenuData from "$lib/core/menuData";
    $: menuData = $MenuData;    

    import { urlFor } from "$lib/core/sanity.js";

    let displaySection = false;
    let currentSection = [];
    function openSectionAccordion(data){
        currentSection = data;
        displaySection = true;
        scrollIntoDetails();
    }

    const delayForEachRow = 200;
    function calculateDelayByIndex(sectionIndex){
        return delayForEachRow * (sectionIndex / 2);        
    }

    //const columnsInGrid = 2;

    // let bannerRowIndex = 0;
    // let bannerGirdPositionIndex = 0;
	// let hasActivePromotions = false;

    let draw
    
    onMount(async () => {
		//hasActivePromotions = menuData.promoData.hasActivePromotions;
		//bannerRowIndex = menuData.promoData.currentPromotion.bannerRowIndex;

        // Actual position between category elements
        //bannerGirdPositionIndex = bannerRowIndex * columnsInGrid;
	});

</script>

    <div class="menu-grid">

        <h2 class="title" in:fly|global="{{ y: 50, duration: 2000 }}">Nuestros Servicios</h2>
        <span class="description" in:fly|global="{{ y: 50, duration: 2000, delay: 400 }}"></span>

        {#each menuData.catalog as menuSection, sectionIndex}

            <!-- {#if hasActivePromotions && sectionIndex == bannerGirdPositionIndex}
                <Banner/>            
            {/if} -->

            {#if menuSection.isVisible}    

            <div class="category-cards">

                <Card title={menuSection.title} description={menuSection.description} 
                    imageUrl={menuSection.poster != null ? urlFor(menuSection.poster.asset) : "/PlaceholderImage.jpg"}
                    link={"/submenu/" + menuSection.name} displayImage={true} buttonLabel="Ver Tratamientos" />
            
            </div>

            {/if}                         

        {/each}

    </div>

<style lang="scss">	



</style>
